import type {KeyboardEventHandler} from 'react'

export const onButtonKeyEvent = (fn: KeyboardEventHandler): KeyboardEventHandler =>  (event) => {
  if (event.code === 'Enter' || event.code === 'Space') {
    fn(event)
  }
}
